import React from "react";
import {Header} from "./HTMLWrappers"

export function FormDialog({
    showDialog,
    setShowDialog,
    formHeader,
    formElements,
    submitButtonMessage,
    onFormSubmit,
    closeAfterAction=true
}){

    function closeModal() {
        setShowDialog(false);
    }

    function onSubmit(event) {
        event.preventDefault();
        onFormSubmit();
        if(closeAfterAction)
            setShowDialog(false);

    }

    if(!showDialog){
        return ""
    }

    return(
        <div className="modal">
            <div class="modal-content">
            <form id="myForm" >
                <div>
                    <Header name={formHeader}/>
                    
                    <div>{formElements}</div>      
                   
                </div>

           
                <div className="clearfix">
                    <div className="row">
                    <div className="col">
                        <button className="ipc dialogbtn" onClick={closeModal}>
                            Cancel
                        </button>
                    </div>
                    <div className="col">
                        <button type="submit" className="ipc dialogbtn" onClick={e=>onSubmit(e)}>
                        {submitButtonMessage}
                        </button>
                    </div>
                    </div>
                </div>
            </form>
            </div>

        </div>
    )
}